import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { BIGCOMMERCE_API_HOSTNAME } from '../../../../constants/global';
import { searchListItems } from '../../../../constants/menus';
import { CONTACT_US_PAGE, SEARCH_PAGE } from '../../../../constants/page-links';
import { useOnSearchKeyDown } from '../../../../hooks/useOnSearchKeyDown';
import { convertStringToLowercase } from '../../../../utils/convertValues';
import { getURLPathname } from '../../../../utils/parseURL';
import { MediaComponents } from '../../../episerver/media';
import { getHeaderMenuMediaItem } from '../../../../utils/getSrcSetByRatio';
import { useScreen } from '../../../../hooks/useScreen';

export const BedTopHeaderListItem = (props) => {
  const { item = null } = props;

  let updatedUrl =
    typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
      ? getURLPathname(item.contentLink.url)
      : '#';

  let linkUrl = '#';

  if (typeof updatedUrl === 'string' && updatedUrl?.length > 0) {
    linkUrl = updatedUrl;

    if (item?.contentType.includes('ProductPage')) {
      if (updatedUrl?.includes('/beds/')) {
        linkUrl = updatedUrl.replace('/beds/', '/products/');
      } else {
        linkUrl = `/products${updatedUrl}`;
      }
    }
  }

  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const listImageContentType = item?.listImage?.expanded?.contentType;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listSubHeading =
    typeof item?.listSubHeading === 'string' && item?.listSubHeading?.length > 0 ? item.listSubHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return (
    <li className="primary-navigation__list-item">
      <Link to={linkUrl}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}

          {typeof listSubHeading === 'string' && listSubHeading?.length > 0 ? (
            <p className="primary-navigation__list-item-header-sub-heading" aria-label={listSubHeading}>
              {listSubHeading}
            </p>
          ) : null}
        </div>

        <div className="primary-navigation__list-item-image">
          {secondaryListImageUrl && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={item?.secondaryListImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.secondaryListImage?.expanded?.width || 0,
                  item?.secondaryListImage?.expanded?.height || 0
                )
              ]}
            />
          )}

          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              alt={listImageDescription}
              contentType={listImageContentType}
              srcSet={[
                ...getHeaderMenuMediaItem(item?.listImage?.expanded?.width || 0, item?.listImage?.expanded?.height || 0)
              ]}
            />
          )}

          {!listImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[191px] object-cover"
            />
          ) : null}
        </div>

        {(typeof listImageDescription === 'string' && listImageDescription?.length > 0) ||
        (typeof payoff === 'string' && payoff?.length > 0) ? (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        ) : null}
      </Link>
    </li>
  );
};

BedTopHeaderListItem.propTypes = {
  item: PropTypes.object
};

export const BedBottomHeaderListItem = (props) => {
  const { item = null } = props;

  let updatedUrl =
    typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
      ? getURLPathname(item.contentLink.url)
      : '#';

  const url = typeof updatedUrl === 'string' && updatedUrl?.length > 0 ? updatedUrl : '#';
  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listSubHeading =
    typeof item?.listSubHeading === 'string' && item?.listSubHeading?.length > 0 ? item.listSubHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return (
    <li className="primary-navigation__list-item">
      <Link to={url}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}

          {typeof listSubHeading === 'string' && listSubHeading?.length > 0 ? (
            <p className="primary-navigation__list-item-header-sub-heading" aria-label={listSubHeading}>
              {listSubHeading}
            </p>
          ) : null}
        </div>

        <div className="primary-navigation__list-item-image">
          {secondaryListImageUrl && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={item?.secondaryListImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.secondaryListImage?.expanded?.width || 0,
                  item?.secondaryListImage?.expanded?.height || 0
                )
              ]}
            />
          )}

          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              alt={listImageDescription}
              contentType={item?.listImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(item?.listImage?.expanded?.width || 0, item?.listImage?.expanded?.height || 0)
              ]}
            />
          )}

          {!listImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[191px] object-cover"
            />
          ) : null}
        </div>

        {(listImageDescription || payoff) && (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        )}
      </Link>
    </li>
  );
};

BedBottomHeaderListItem.propTypes = {
  item: PropTypes.object
};

export const FurnitureTopHeaderListItem = (props) => {
  const { item = null, count } = props;
  const { isMobile } = useScreen();

  const url =
    typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
      ? getURLPathname(item.contentLink.url)
      : '#';
  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listSubHeading =
    typeof item?.listSubHeading === 'string' && item?.listSubHeading?.length > 0 ? item.listSubHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return item && Object.prototype.toString.call(item) === '[object Object]' && Object.keys(item)?.length > 0 ? (
    <li className="primary-navigation__list-item text-inverted navigation--image-dark w-full">
      <Link to={url}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}

          {typeof listSubHeading === 'string' && listSubHeading?.length > 0 ? (
            <p className="primary-navigation__list-item-header-sub-heading" aria-label={listSubHeading}>
              {listSubHeading}
            </p>
          ) : null}

          {typeof listImageDescription === 'string' && listImageDescription?.length > 0 ? (
            <p className="primary-navigation__list-item-header-description" aria-label={listImageDescription}>
              {listImageDescription}
            </p>
          ) : null}
        </div>

        <div className={`primary-navigation__list-item-image ${isMobile && 'aspect-square'}`}>
          {secondaryListImageUrl && (!listImageUrl || !isMobile) && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={item?.secondaryListImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.secondaryListImage?.expanded?.width || 0,
                  item?.secondaryListImage?.expanded?.height || 0,
                  count
                )
              ]}
            />
          )}

          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              alt={listImageDescription}
              contentType={item?.listImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.listImage?.expanded?.width || 0,
                  item?.listImage?.expanded?.height || 0,
                  count
                )
              ]}
            />
          )}
          {!listImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[191px] object-cover"
            />
          ) : null}
        </div>

        {(typeof listImageDescription === 'string' && listImageDescription?.length > 0) ||
        (typeof payoff === 'string' && payoff?.length > 0) ? (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        ) : null}
      </Link>
    </li>
  ) : null;
};

FurnitureTopHeaderListItem.propTypes = {
  item: PropTypes.object
};

export const FurnitureBottomHeaderListItem = (props) => {
  const { item = null, count } = props;

  const urlPathname =
    typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
      ? getURLPathname(item?.contentLink?.url)
      : '#';
  const splitUrlPathname =
    urlPathname?.split('/')?.length > 0 && urlPathname?.includes('furniture')
      ? urlPathname?.split('/')[urlPathname?.split('/').length - 1]
      : urlPathname;

  const url = `/${splitUrlPathname?.replace('/', '')}`;

  let specialMenu = ['/ritzy-collection'];
  let newLink = '';

  if (specialMenu.includes(url)) {
    newLink = `/furniture${url}`;
  } else {
    newLink = url;
  }

  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const topImageUrl = item?.topImage?.expanded?.contentLink?.url;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listSubHeading =
    typeof item?.listSubHeading === 'string' && item?.listSubHeading?.length > 0 ? item.listSubHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return item && Object.prototype.toString.call(item) === '[object Object]' && Object.keys(item)?.length > 0 ? (
    <li className="primary-navigation__list-item">
      <Link to={newLink || '#'}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}

          {typeof listSubHeading === 'string' && listSubHeading?.length > 0 ? (
            <p className="primary-navigation__list-item-header-sub-heading" aria-label={listSubHeading}>
              {listSubHeading}
            </p>
          ) : null}
        </div>

        <div className="primary-navigation__list-item-image">
          {topImageUrl ? (
            <MediaComponents
              url={topImageUrl}
              contentType={item?.topImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.topImage?.expanded?.width || 0,
                  item?.topImage?.expanded?.height || 0,
                  count
                )
              ]}
            />
          ) : (
            <>
              {secondaryListImageUrl && (
                <MediaComponents
                  url={secondaryListImageUrl}
                  contentType={item?.secondaryListImage?.expanded?.contentType}
                  srcSet={[
                    ...getHeaderMenuMediaItem(
                      item?.secondaryListImage?.expanded?.width || 0,
                      item?.secondaryListImage?.expanded?.height || 0,
                      count
                    )
                  ]}
                />
              )}

              {listImageUrl && (
                <MediaComponents
                  url={listImageUrl}
                  alt={listImageDescription}
                  contentType={item?.listImage?.expanded?.contentType}
                  srcSet={[
                    ...getHeaderMenuMediaItem(
                      item?.listImage?.expanded?.width || 0,
                      item?.listImage?.expanded?.height || 0
                    )
                  ]}
                />
              )}
            </>
          )}

          {!listImageUrl && !topImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[140px] object-cover"
            />
          ) : null}
        </div>

        {(typeof listImageDescription === 'string' && listImageDescription?.length > 0) ||
        (typeof payoff === 'string' && payoff?.length > 0) ? (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        ) : null}
      </Link>
    </li>
  ) : null;
};

export const BeddingTopHeaderListItem = memo(function MemoizedBeddingTopHeaderListItem(props) {
  const { item = null, count } = props;
  const { isMobile } = useScreen();

  const url =
    typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
      ? getURLPathname(item.contentLink.url)
      : '#';
  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listSubHeading =
    typeof item?.listSubHeading === 'string' && item?.listSubHeading?.length > 0 ? item.listSubHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return (
    <li className="primary-navigation__list-item text-inverted navigation--image-dark w-full">
      <Link to={url}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}

          {typeof listSubHeading === 'string' && listSubHeading?.length > 0 ? (
            <p className="primary-navigation__list-item-header-sub-heading" aria-label={listSubHeading}>
              {listSubHeading}
            </p>
          ) : null}
        </div>

        <div className={`primary-navigation__list-item-image ${isMobile && 'aspect-square'}`}>
          {secondaryListImageUrl && (!listImageUrl || !isMobile) && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={item?.secondaryListImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.secondaryListImage?.expanded?.width || 0,
                  item?.secondaryListImage?.expanded?.height || 0,
                  count
                )
              ]}
            />
          )}

          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              alt={listImageDescription}
              contentType={item?.listImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.listImage?.expanded?.width || 0,
                  item?.listImage?.expanded?.height || 0,
                  count
                )
              ]}
            />
          )}

          {!listImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[191px] object-cover"
            />
          ) : null}
        </div>

        {(listImageDescription || payoff) && (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        )}
      </Link>
    </li>
  );
});

BeddingTopHeaderListItem.propTypes = {
  item: PropTypes.object
};

export const BeddingBottomHeaderListItem = memo(function MemoizedBeddingBottomHeaderListItem(props) {
  const { item = null } = props;

  const url =
    typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
      ? getURLPathname(item.contentLink.url)
      : '#';
  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return (
    <li className="primary-navigation__list-item">
      <Link to={url}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}
        </div>

        <div className="primary-navigation__list-item-image">
          {secondaryListImageUrl && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={item?.secondaryListImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.secondaryListImage?.expanded?.width || 0,
                  item?.secondaryListImage?.expanded?.height || 0
                )
              ]}
            />
          )}

          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              alt={listImageDescription}
              contentType={item?.listImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(item?.listImage?.expanded?.width || 0, item?.listImage?.expanded?.height || 0)
              ]}
            />
          )}

          {!listImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[191px] object-cover"
            />
          ) : null}
        </div>

        {(typeof listImageDescription === 'string' && listImageDescription?.length > 0) ||
        (typeof payoff === 'string' && payoff?.length > 0) ? (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        ) : null}
      </Link>
    </li>
  );
});

BeddingBottomHeaderListItem.propTypes = {
  item: PropTypes.object
};

export const WhyDuxTopHeaderListItem = (props) => {
  const { item = null, count } = props;
  const { isMobile } = useScreen();

  const url = item?.contentLink?.url ? getURLPathname(item.contentLink.url) : '#';
  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listSubHeading =
    typeof item?.listSubHeading === 'string' && item?.listSubHeading?.length > 0 ? item.listSubHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return (
    <li className="primary-navigation__list-item text-inverted navigation--image-dark">
      <Link to={url}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}

          {typeof listSubHeading === 'string' && listSubHeading?.length > 0 ? (
            <p className="primary-navigation__list-item-header-sub-heading" aria-label={listSubHeading}>
              {listSubHeading}
            </p>
          ) : null}
        </div>

        <div className={`primary-navigation__list-item-image ${isMobile && 'aspect-square'}`}>
          {secondaryListImageUrl && (!listImageUrl || !isMobile) && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={item?.secondaryListImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.secondaryListImage?.expanded?.width || 0,
                  item?.secondaryListImage?.expanded?.height || 0,
                  count
                )
              ]}
            />
          )}

          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              alt={listImageDescription}
              contentType={item?.listImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.listImage?.expanded?.width || 0,
                  item?.listImage?.expanded?.height || 0,
                  count
                )
              ]}
            />
          )}

          {!listImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[380px] object-cover"
            />
          ) : null}
        </div>

        {(typeof listImageDescription === 'string' && listImageDescription?.length > 0) ||
        (typeof payoff === 'string' && payoff?.length > 0) ? (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        ) : null}
      </Link>
    </li>
  );
};

export const WhyDuxBottomHeaderListItem = memo(function MemoizedWhyDuxBottomHeaderListItem(props) {
  const { item = null } = props;

  const url =
    typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
      ? getURLPathname(item.contentLink.url)
      : '#';
  const listImageUrl = item?.listImage?.expanded?.contentLink?.url;
  const listHeading = typeof item?.listHeading === 'string' && item?.listHeading?.length > 0 ? item.listHeading : null;
  const listSubHeading =
    typeof item?.listSubHeading === 'string' && item?.listSubHeading?.length > 0 ? item.listSubHeading : null;
  const listImageDescription =
    typeof item?.listImageDescription === 'string' && item?.listImageDescription?.length > 0
      ? item.listImageDescription
      : null;
  const secondaryListImageUrl = item?.secondaryListImage?.expanded?.contentLink?.url;
  const payoff = typeof item?.payoff === 'string' && item?.payoff?.length > 0 ? item.payoff : null;
  const name = typeof item?.name && item?.name?.length > 0 ? item.name : null;

  if (!item || !Object.keys(item)?.length) return null;

  return item && Object.prototype.toString.call(item) === '[object Object]' && Object.keys(item)?.length > 0 ? (
    <li className="primary-navigation__list-item">
      <Link to={url}>
        <div className="primary-navigation__list-item-header">
          {(typeof listHeading === 'string' && listHeading?.length > 0) ||
          (typeof name === 'string' && name?.length > 0) ? (
            <p className="primary-navigation__list-item-header-heading" aria-label={listHeading || name}>
              {listHeading || name}
            </p>
          ) : null}

          {typeof listSubHeading === 'string' && listSubHeading?.length > 0 ? (
            <p className="primary-navigation__list-item-header-sub-heading" aria-label={listSubHeading}>
              {listSubHeading}
            </p>
          ) : null}
        </div>

        <div className="primary-navigation__list-item-image">
          {secondaryListImageUrl && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={item?.secondaryListImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.secondaryListImage?.expanded?.width || 0,
                  item?.secondaryListImage?.expanded?.height || 0
                )
              ]}
            />
          )}

          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              alt={listImageDescription}
              contentType={item?.listImage?.expanded?.contentType}
              srcSet={[
                ...getHeaderMenuMediaItem(item?.listImage?.expanded?.width || 0, item?.listImage?.expanded?.height || 0)
              ]}
            />
          )}

          {!listImageUrl && !secondaryListImageUrl ? (
            <StaticImage
              src="../../../../images/duxiana-placeholder.jpg"
              alt="Duxiana placeholder image"
              className="h-[191px] object-cover"
            />
          ) : null}
        </div>

        {(typeof listImageDescription === 'string' && listImageDescription?.length > 0) ||
        (typeof payoff === 'string' && payoff?.length > 0) ? (
          <div className="primary-navigation__sub-list">
            <p>{listImageDescription || payoff}</p>
          </div>
        ) : null}
      </Link>
    </li>
  ) : null;
});

WhyDuxBottomHeaderListItem.propTypes = {
  item: PropTypes.object
};

export const MoreListItem = ({ item = null }) => {
  const listImageUrl = item.contentLink?.expanded?.page?.expanded?.listImage?.expanded?.contentLink?.url;
  const listImageContentType = item.contentLink?.expanded?.page?.expanded?.listImage?.expanded?.contentType;
  const secondaryListImageUrl =
    item.contentLink?.expanded?.page?.expanded?.secondaryListImage?.expanded?.contentLink?.url;
  const secondaryListImageContentType =
    item.contentLink?.expanded?.page?.expanded?.secondaryListImage?.expanded?.contentType;
  return (
    <li className="primary-navigation__list-item primary-navigation__list-item-more">
      <Link
        to={
          typeof item.contentLink?.expanded?.page?.url === 'string' && item.contentLink?.expanded?.page?.url?.length > 0
            ? getURLPathname(item.contentLink.expanded.page.url)
            : '#'
        }
      >
        <div className="primary-navigation__list-item-header">
          <p
            className="primary-navigation__list-item-header-heading"
            aria-label={convertStringToLowercase(
              item?.contentLink?.expanded?.page?.expanded?.listHeading ||
                item?.contentLink?.expanded?.page?.expanded?.name ||
                ''
            )}
          >
            {item?.contentLink?.expanded?.page?.expanded?.listHeading ||
              item?.contentLink?.expanded?.page?.expanded?.name ||
              ''}
          </p>

          <p
            className="primary-navigation__list-item-header-description"
            aria-label={convertStringToLowercase(item?.contentLink?.expanded?.page?.expanded?.listSubHeading || '')}
          >
            {item?.contentLink?.expanded?.page?.expanded?.listSubHeading || ''}
          </p>
        </div>
        <div className="primary-navigation__list-item-image">
          {listImageUrl && (
            <MediaComponents
              url={listImageUrl}
              contentType={listImageContentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.contentLink?.expanded?.page?.expanded?.listImage?.expanded?.width || 0,
                  item?.contentLink?.expanded?.page?.expanded?.listImage?.expanded?.height || 0
                )
              ]}
            />
          )}

          {secondaryListImageUrl && (
            <MediaComponents
              url={secondaryListImageUrl}
              contentType={secondaryListImageContentType}
              srcSet={[
                ...getHeaderMenuMediaItem(
                  item?.contentLink?.expanded?.page?.expanded?.secondaryListImage?.expanded?.width || 0,
                  item?.contentLink?.expanded?.page?.expanded?.secondaryListImage?.expanded?.height || 0
                )
              ]}
            />
          )}
        </div>
      </Link>

      <div className="primary-navigation__sub-list primary-navigation__sub-list--has-children">
        {item.contentLink.expanded?.page?.expanded?.listImageDescription && (
          <p>{item.contentLink.expanded.page.expanded.listImageDescription}</p>
        )}

        {item?.contentLink?.expanded?.subMenusTop?.length > 0 && (
          <ul>
            {item.contentLink.expanded.subMenusTop.map(
              (subMenu, index) =>
                !!subMenu.contentLink?.expanded?.contentLink?.url &&
                !!subMenu.contentLink?.expanded?.name && (
                  <li
                    key={
                      typeof subMenu.contentLink?.id === 'number' && subMenu.contentLink?.id > 0
                        ? subMenu.contentLink.id
                        : index
                    }
                  >
                    <Link to={getURLPathname(subMenu.contentLink.expanded.contentLink.url)}>
                      {subMenu.contentLink.expanded.name}
                    </Link>
                  </li>
                )
            )}
          </ul>
        )}

        {item?.contentLink?.expanded?.subMenusBottom?.length > 0 && (
          <ul>
            {item.contentLink.expanded.subMenusBottom.map(
              (subMenu, index) =>
                !!subMenu.contentLink?.expanded?.contentLink?.url &&
                !!subMenu.contentLink?.expanded?.name && (
                  <li
                    key={
                      typeof subMenu.contentLink?.id === 'number' && subMenu.contentLink?.id > 0
                        ? subMenu.contentLink.id
                        : index
                    }
                  >
                    <Link to={getURLPathname(subMenu.contentLink.expanded.contentLink.url)}>
                      {subMenu.contentLink.expanded.name}
                    </Link>
                  </li>
                )
            )}
          </ul>
        )}
      </div>
    </li>
  );
};
/**
 * @description Render memoized search header list item component
 * @param {Object} props
 * @returns {JSX.Element} Memoized search header list item component
 */
export const SearchHeaderListItem = (props) => {
  const { ref: searchRef, setHandler: setSearchHandler } = useOnSearchKeyDown();

  const handleSearchInput = (ref, event) => {
    if (event && ref) {
      setSearchHandler(() => {
        if (event.key === 'Enter') {
          ref?.current.focus();
          if (typeof window !== 'undefined') {
            window.location = SEARCH_PAGE + '?q=' + event?.currentTarget?.value;
          }
        }
      });
    }

    return ref;
  };

  // Translations
  const submitText = 'Submit';
  const contactUsText = 'Contact us';
  const closeSearchText = 'Close search';
  const autoSuggestionsText = 'Provides auto-suggestions when entering text';
  const areYouLookingForText = 'Are you looking for:';
  const searchText = 'Search';

  const replaceUrlProduct = (urlProduct) =>
    urlProduct.startsWith(`${BIGCOMMERCE_API_HOSTNAME + '/products'}`)
      ? urlProduct.replace(`${BIGCOMMERCE_API_HOSTNAME + '/products'}`, '/products')
      : urlProduct.replace(BIGCOMMERCE_API_HOSTNAME, '/products');

  return (
    <li
      id="search__page"
      className={`primary-navigation__item ${props.hideSearchPanel && 'hidden'}`}
      role="menuitem"
      aria-hidden="true"
    >
      <div className="search-dropdown">
        <div className="search-dropdown__inner">
          <a className="close-search" id="close-search" href="#" role="button">
            <span className="sr-only">{closeSearchText}</span>
          </a>
          <div className="search">
            <div className="search__input">
              <form id="search-form" ref={searchRef}>
                <span className="sr-only" id="suggestions-help">
                  {autoSuggestionsText}
                </span>
                <input type="hidden" name="windowWidth" value="1835" />
                <input type="hidden" name="replaceurl" value="false" />
                <label className="sr-only" htmlFor="q">
                  {searchText}
                </label>
                <input
                  name="q"
                  id="q"
                  aria-describedby="suggestions-help announce"
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  onKeyDown={(e) => handleSearchInput(searchRef, e)}
                  onInput={(e) => handleSearchInput(searchRef, e)}
                />
                <button type="submit" className="sr-only">
                  {submitText}
                </button>
                <span className="autocomplete-suggestions"></span>
              </form>
            </div>
            <div className="search__list">
              <h2 aria-label={convertStringToLowercase(areYouLookingForText)}>{areYouLookingForText}</h2>
              <div className="featured-pages">
                <ul>
                  {searchListItems.map((item, index) => (
                    <li key={item.url || index} className="featured-page">
                      <Link to={item.url}>
                        <span>{item.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="contact-us">
                <Link to={CONTACT_US_PAGE} className="btn btn--primary btn--small">
                  <span>{contactUsText}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

SearchHeaderListItem.propTypes = {
  searchQuery: PropTypes.string,
  searchResults: PropTypes.array,
  setSearchQuery: PropTypes.func
};
